<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0 bg-logo"
        style="background-color:#3f3939"
      >
        <!-- <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="logo"
          />
        </div> -->
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Alteração de senha
          </b-card-title>
          <b-card-text class="mb-2">
            Por favor, altere sua senha
          </b-card-text>

          <!-- form -->
          <validation-observer ref="validacao">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="E-mail"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.login"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="pessoa@email.com.br"
                  />
                  <small class="text-danger">{{ errors.length > 0 ? 'Informe o e-mail' : null }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                </div>
                <senha-input
                  v-model="form.senha"
                  required
                />
              </b-form-group>

              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-new-password">Nova senha</label>
                </div>
                <senha-input
                  v-model="form.novaSenha"
                  required
                  :validacao-nome="'Nova senha'"
                />
              </b-form-group>

              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-confirm-password">Confirmar senha</label>
                </div>
                <senha-input
                  v-model="form.confirmarSenha"
                  required
                  :validacao-nome="'Confirmar senha'"
                />
                <small class="text-danger">{{ loginError }}</small>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="autenticar"
              >
                Entrar
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import useJwt from '@/auth/jwt/useJwt'
import { clearLoggedIn } from '@/auth/utils'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  data() {
    return {
      form: {
        login: '',
        senha: '',
        novaSenha: '',
        confirmarSenha: '',
      },
      loginError: '',
      logo: require('@/assets/images/logo/logocompleta.png'),
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      return require('@/assets/images/pages/logininterno.png')
    },
  },
  created() {
    clearLoggedIn()
  },
  methods: {
    autenticar() {
      this.loginError = ''
      this.$refs.validacao.validate()
        .then(() => {
          this.form.login = this.form.login.trim()
          useJwt.alterarSenha(this.form)
            .then(response => {
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))

              this.$router.push({ name: 'portaldocumentos-inerno' })
            })
            .catch(error => {
              const resolved = this.$resolveError(error)
              const message = resolved.detail || resolved.title
              this.loginError = message
              this.$refs.validacao.setErrors({ Password: message })
              this.$handleError(error)
            })
        })
    },
  },
}
</script>
